(function () {

    'use strict';

    var MergeUserTagsCtrl = function ($scope, ajaxCall, xmsNotificationFactory, $uibModalInstance, passedModel) {

        console.log('MergeUserTagsCtrl init!');

        if (!angular.isDefined(passedModel)) {
            passedModel = {};
        }
        $scope.ngModel = passedModel;

        $scope.ok = function () {
            $uibModalInstance.close(this.ngModel);
            location.reload();
        };

        $scope.getIds = function(){
            var ids = [];
            angular.forEach(passedModel.tags, function(value) {
                ids.push(value.id);
            });
            return ids.join(',');
        }

        $scope.cancel = function (e) {
            if (angular.isDefined(e)) {
                e.preventDefault();
            }
            $uibModalInstance.dismiss('cancel');
        };

        $scope.save = function ($event) {
            $event.preventDefault();
            var tagName = $("input[name='newTagName']").val();
            if (tagName != null && tagName != ""){
                var data = $scope.ngModel;
                var ajaxUrl
                if($("input[name='origin']").val()=='listTags')
                {
                    ajaxUrl   = WEBAPP_PATH + "/tagAdmin/mergeListTags";
                }
                else {
                     ajaxUrl = WEBAPP_PATH + "/tagAdmin/mergeUserTags";
                }
                ajaxCall.getData(ajaxUrl, data).then(function(result) {
                    if (result.data.success == true) {
                        if(result.data.response.type == "success") {
                            if(new String($scope.ngModel.redirectURL).indexOf("?") == -1) {
                                window.location.href = $scope.ngModel.redirectURL + "?alertType=" + result.data.response.type + "&alertMessage=" + result.data.response.message;
                            } else {
                                window.location.href = $scope.ngModel.redirectURL + "&alertType=" + result.data.response.type + "&alertMessage=" + result.data.response.message;
                            }
                        } else {
                            xmsNotificationFactory.bulk(result.data.response.message, result.data.response.type);
                        }
                        $scope.cancel();
                    }
                }, function(result) {
                    xmsNotificationFactory.bulk("Error: Unable to process your request", "danger");
                    $scope.cancel();
                    console.log("Error in MergeUserTagsCtrl.js", result);
                });
            }
            $scope.ok();
            return true;
        };
    };

    MergeUserTagsCtrl.$inject = ['$scope', 'ajaxCall', 'xmsNotificationFactory', '$uibModalInstance', 'params'];
    angular.module('app').controller('MergeUserTagsCtrl', MergeUserTagsCtrl);
}());